import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm, formValueSelector } from 'redux-form';
import { withRouter } from 'react-router-dom';
import Titulo from '../comum/Titulo';
import { getPerfisVendedores } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import AbaItinerario from './AbaItinerario';
import buscarCaixaAberto from '../../actions/fechamento-caixa/usuario/buscarCaixaAberto';
import selecionarEnderecoDestinatario from '../../actions/endereco/selecionarEnderecoDestinatario';
import selecionarEnderecoRemetente from '../../actions/endereco/selecionarEnderecoRemetente';
import buscarPessoaRemetentePorCpfCnpj from '../../actions/pessoa/buscarPessoaRemetentePorCpfCnpj';
import buscarPessoaDestinatarioPorCpfCnpj from '../../actions/pessoa/buscarPessoaDestinatarioPorCpfCnpj';
import selecionarPessoaRemetente from '../../actions/pessoa/selecionarPessoaRemetente';
import selecionarPessoaDestinatario from '../../actions/pessoa/selecionarPessoaDestinatario';
import selecionarDataIda from '../../actions/origem/selecionarDataIda';
import AbaRemetente from './AbaRemetente';
import AbaDestinatario from './AbaDestinatario';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarViagem from '../../actions/viagem/selecionarViagem';
import limparViagens from '../../actions/viagem/limpaViagens';
import AbaPagamento, { VALOR_POR_METRO_CUBICO } from './AbaPagamento';
import AbaResumo from './AbaResumo';
import cadastrarEncomenda from '../../actions/encomenda/cadastrarEncomenda';
import limparDadosPagamentoEncomenda from '../../actions/encomenda/limparDadosPagamentoEncomenda';
import { showSuccessMsg, showErrorMsg } from '../../util/messagesUtil';
import adicionarFormasPagamentoEncomenda from '../../actions/encomenda/adicionarFormasPagamentoEncomenda';
import { arredondamentoPadrao, realParaNumber } from '../../util/numberUtil';
import buscarConfiguracaoEncomenda from '../../actions/empresa/buscarConfiguracaoEncomenda';
import AbaCte from './AbaCte';
import buscarOpcoesFiltrosEmissaoesCte from '../../actions/cteos/buscarOpcoesFiltrosEmissaoesCte';
import buscarSeUsuarioVendeEncomendaComCte from '../../actions/usuario/buscarSeUsuarioVendeEncomendaComCte';
import adicionarDadosCteEncomenda from '../../actions/encomenda/adicionarDadosCteEncomenda';
import limparDadosCteEncomenda from '../../actions/encomenda/limparDadosCteEncomenda';

export class PainelCadastroEncomenda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      abaSelecionada: 1,
      seFormaPagamentoNaoFoiSelecionado: true,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.buscarCaixaAberto(this.props.empresaSelecionada.id);
      this.props.buscarConfiguracaoEncomenda(this.props.empresaSelecionada.id);
      this.props.buscarOpcoesFiltrosEmissaoesCte(this.props.empresaSelecionada.id).catch(() => {});
      this.props.buscarSeUsuarioVendeEncomendaComCte(this.props.empresaSelecionada.id);
    }
    this.limparTudo();
  }
  
  limparTudo() {
    this.props.selecionarPessoaRemetente({});
    this.props.selecionarPessoaDestinatario({});
    this.props.selecionarViagem({});
    this.props.selecionarEnderecoDestinatario(null);
    this.props.selecionarEnderecoRemetente(null);
    this.props.selecionarDataIda(null);
    this.props.selecionarDestino(null);
    this.props.selecionarOrigem(null);
    this.props.limparViagens();
    this.props.limparDadosPagamentoEncomenda();
    this.props.limparDadosCteEncomenda();
    this.setState({ abaSelecionada: 1 })
  }

  avancar() {
    if (this.state.abaSelecionada === 4) {
      if (this.props.usuarioVendeEncomendaComCte) {
        this.setState({ abaSelecionada: this.state.abaSelecionada + 1 })
      } else {
        this.setState({ abaSelecionada: this.state.abaSelecionada + 2 })
      }      
    } else {
      this.setState({ abaSelecionada: this.state.abaSelecionada + 1 })
    }    
    
  }

  voltar() {
    if (this.state.abaSelecionada === 6) {
      if (this.props.usuarioVendeEncomendaComCte) {
        this.setState({ abaSelecionada: this.state.abaSelecionada - 1 })
      } else {
        this.setState({ abaSelecionada: this.state.abaSelecionada - 2 })
      }
    } else {
      this.setState({ abaSelecionada: this.state.abaSelecionada - 1 })
    }
  }

  montarEmitenteCteAnterior() {
    const emitente = this.props.dadosCteEncomenda.emitenteCteAnterior || {};
    const cidade = emitente.cidade || {};
    return {
      cpjCnpj: emitente.numeroCnpj,
      nome: emitente.nomeFantasia,
      razaoSocial: emitente.razaoSocial,
      inscricaoEstadual: emitente.inscricaoEstadual,
      uf: cidade.uf,
      chaveCte: emitente.chaveCte,
      tipoIndicadorContribuicao: emitente.tipoIndicadorContribuicaoIE && emitente.tipoIndicadorContribuicaoIE.value,
      enderecoDto: {
        cep: emitente.cep,
        logradouro: emitente.logradouro,
        complemento: emitente.complemento,
        bairro: emitente.bairro,
        codigoCidade: cidade.id,
        uf: cidade.uf,
        numero: emitente.numero,
        localidade: cidade.nome,
        nomeCidade: cidade.nome
      }
    };
  }

  criarEncomenda() {
    const metroCubicoVolumeTotal = this.props.dadosPagamentoEncomenda.tipoCalculo.value === VALOR_POR_METRO_CUBICO
      ? Number(String(this.props.dadosPagamentoEncomenda.volumeM3 || '')
        .replace(/\./g, '')
        .replace(',', '.'))
      : null;
    const volumeUnitarioBackend = (it) => {
      const n = (v) => Number(String(v ?? '').replace(/\./g, '').replace(',', '.')) || 0;
      return arredondamentoPadrao(n(it.comprimento) * n(it.largura) * n(it.altura) / 1000000);
    };
    const parametros = {
      descricaoProduto: this.props.dadosPagamentoEncomenda.tipoProduto,
      volume: this.props.dadosPagamentoEncomenda.volume,
      observacao: this.props.dadosPagamentoEncomenda.observacao,
      peso: this.props.dadosPagamentoEncomenda.quantidadeKg,
      valorCombinado: this.props.dadosPagamentoEncomenda.valorCombinado ? this.props.dadosPagamentoEncomenda.valorCombinado.replace('R$', '') : null,
      tipoCalculo: this.props.dadosPagamentoEncomenda.tipoCalculo.value,
      cidadeOrigemId: this.props.origem.id,
      cidadeDestinoId: this.props.destino.id,
      itinerarioId: this.props.viagem.idItinerario,
      empresaId: this.props.empresaSelecionada.id,
      pessoaRemetenteId: this.props.pessoaRemetente.id,
      pessoaDestinarioId: this.props.pessoaDestinatario.id,
      enderecoRemetenteId: this.props.enderecoRemetente.id,
      enderecoDestinarioId: this.props.enderecoDestinatario.id,
      formasPagamento: this.props.dadosPagamentoEncomenda.formasPagamento.map(it => ({
        tipo: it.tipo,
        codigoTipo: it.codigoTipo,
        base64Comprovante: it.base64Comprovante,
        numeroComprovante: it.numeroComprovante,
        nomeComprovante: it.nomeComprovanteVenda,
        valor: it.valor,
        quantidadeParcelas: it.quantidadeParcelas
      })),
      notasFiscais: this.props.dadosPagamentoEncomenda.notasFiscais.map(it => ({
        numeroDocumento: it.numeroDocumento,
        peso: it.peso,
        valor: it.valor ? it.valor.replace('R$', '') : null,
        quantidade: it.volume
      })),
      habilitadoSeguro: this.props.dadosPagamentoEncomenda.habilitadoSeguro,
      valorProduto: this.props.dadosPagamentoEncomenda.valorProduto,
      habilitadoValorDeclarado: this.props.dadosPagamentoEncomenda.habilitadoValorDeclarado,
      habilitaValorNotaFiscal: this.props.dadosPagamentoEncomenda.habilitaValorNotaFiscal,
      imagens: this.props.imagens,
      rntrc: this.props.dadosCteEncomenda.rntrc,
      naturezaOperacao: this.props.dadosCteEncomenda.naturezaOperacao.value ? Number(this.props.dadosCteEncomenda.naturezaOperacao.value) : null,
      tipoServicoCte: this.props.dadosCteEncomenda.tipoServicoCte.value,
      chaveNfe: this.props.dadosCteEncomenda.chaveNfe,
      habilitadoChaveCteAnterior: this.props.dadosCteEncomenda.habilitadoChaveCteAnterior || false,
      emitenteCteAnterior: this.props.dadosCteEncomenda.habilitadoChaveCteAnterior
        ? this.montarEmitenteCteAnterior()
        : null
    }

    if (this.props.dadosPagamentoEncomenda.tipoCalculo.value === VALOR_POR_METRO_CUBICO) {      
      parametros.volumteTotalMetroCubico = metroCubicoVolumeTotal;      
      parametros.itensMetroCubico = (this.props.dadosPagamentoEncomenda.itensMetroCubico || []).map(it => ({
        descricao: it.descricao,
        comprimento: Number(String(it.comprimento ?? '').replace(/\./g, '').replace(',', '.')) || 0,
        largura: Number(String(it.largura ?? '').replace(/\./g, '').replace(',', '.')) || 0,
        altura: Number(String(it.altura ?? '').replace(/\./g, '').replace(',', '.')) || 0,
        volumeUnitario: volumeUnitarioBackend(it)
      }));
    }

    console.log('parametros: ', parametros)

    this.props.cadastrarEncomenda(parametros).then((resp) => {
      showSuccessMsg('Encomenda cadastrada com sucesso');
      this.props.history.push(`/recibo-encomenda?encomenda=${resp.payload.data}`)
      this.limparTudo();
    }).catch((err) => {
      const status = err && err.response && err.response.status;
      if (status === 413) {
        showErrorMsg('Imagem(ns) muito grande(s). Reduza o tamanho ou remova as imagens e tente novamente.');
      } else {
        showErrorMsg('Erro ao cadastrar encomenda. Verifique os dados e tente novamente.');
      }
    })
  }

  abaSelecionada(aba) {
    if (this.state.abaSelecionada >= aba) {
      return 'nav-link active'
    }
    return 'nav-link'
  }

  preencherFormaPagamento() {
    const pagamentos = [];
    if (this.props.cartao) {
      pagamentos.push({
        tipo: 'Cartão',
        codigoTipo: 'CARTAO',
        base64Comprovante: this.props.base64Comprovante,
        numeroComprovante: this.props.numeroComprovante,
        valor: realParaNumber(this.props.valorCartao),
        quantidadeParcelas: Number(this.props.quantidadeParcelas),
        nomeComprovanteVenda: this.props.nomeComprovanteVenda,
      })
    }

    if (this.props.dinheiro) {
      pagamentos.push({
        tipo: 'Dinheiro',
        codigoTipo: 'DINHEIRO',
        base64Comprovante: '',
        numeroComprovante: '',
        valor: realParaNumber(this.props.valorDinheiro),
        quantidadeParcelas: 1,
      })
    }

    if (this.props.pix) {
      pagamentos.push({
          tipo: 'PIX',
          codigoTipo: 'PIX',
          base64Comprovante: this.props.base64ComprovantePIX,
          numeroComprovante: this.props.numeroComprovantePIX,
          valor: realParaNumber(this.props.valorPIX),
          quantidadeParcelas: 1,
          nomeComprovanteVenda: this.props.nomeComprovanteVendaPIX
      })
  }
    this.props.adicionarFormasPagamentoEncomenda(pagamentos);
  }

  verificarSeFormaPagamentoNaoFoiSelecionado(dinheiro, cartao, pix) {
    if(cartao == undefined) cartao = false;
    this.setState({ seFormaPagamentoNaoFoiSelecionado: dinheiro == false && cartao == false && pix == false });
}

  somarValorFormaPagamento() {
    let valorTotalFormaPagamento = 0;
    this.props.dadosPagamentoEncomenda.formasPagamento.forEach(fp => valorTotalFormaPagamento += Number(fp.valor));
    return arredondamentoPadrao(valorTotalFormaPagamento);
  }

  recuperarValorTotal() {
    if (this.props.dadosPagamentoEncomenda.tipoCalculo.value === 'VALOR_COMBINADO') {
      return realParaNumber(this.props.dadosPagamentoEncomenda.valorCombinado)
    }
    return realParaNumber(this.props.dadosPagamentoEncomenda.valorCalculado);
  }

  recuperarValorTotalGeral() {
    if (this.props.dadosPagamentoEncomenda.tipoCalculo.value === 'VALOR_COMBINADO') {
      return realParaNumber(this.props.dadosPagamentoEncomenda.valorCombinado) + this.calcularValorSeguro()
    }
    return realParaNumber(this.props.dadosPagamentoEncomenda.valorCalculado) + this.calcularValorSeguro();
  }

  calcularValorSeguro() {
    if (this.props.dadosPagamentoEncomenda.habilitadoSeguro &&
      this.props.configuracaoEncomenda.habilitadoTaxaSeguro) {
      const taxaSeguro = realParaNumber(this.props.configuracaoEncomenda.taxaSeguro) / 100;

      let valorSeguro = 0;
      if (this.props.dadosPagamentoEncomenda.habilitadoValorDeclarado) {
        valorSeguro = this.props.dadosPagamentoEncomenda.valorProduto * taxaSeguro;
        return valorSeguro;
      }

      if (this.props.dadosPagamentoEncomenda.habilitaValorNotaFiscal) {
        valorSeguro = this.props.dadosPagamentoEncomenda.valorTotalNotaFiscal * taxaSeguro;
        return valorSeguro;
      }

    }

    return 0;
  }

  tratarAvancarCte() {
    if (this.props.usuarioVendeEncomendaComCte) {
      if (!this.props.dadosCteEncomenda.rntrc || !this.props.dadosCteEncomenda.tipoServicoCte.value || !this.props.dadosCteEncomenda.naturezaOperacao.value) {
        return true;
      }

      if (this.props.dadosCteEncomenda.habilitadoChaveCteAnterior) {
        const emitente = this.props.dadosCteEncomenda.emitenteCteAnterior || {};
        return !emitente.chaveCte || !emitente.nomeFantasia || !emitente.razaoSocial || !emitente.numeroCnpj
          || !emitente.tipoIndicadorContribuicaoIE || !emitente.tipoIndicadorContribuicaoIE.value
          || !emitente.cep || !emitente.logradouro || !emitente.bairro || !emitente.numero || !emitente.cidade;
      }

      return !this.props.dadosCteEncomenda.chaveNfe;
    }

    return  this.props.usuarioVendeEncomendaComCte;
  }

  tratarAvancarPagamento() {
    if (this.state.seFormaPagamentoNaoFoiSelecionado) {
      return false;
    }

    if(this.props.dadosPagamentoEncomenda.habilitaValorNotaFiscal) {
      return this.props.dadosPagamentoEncomenda.valorTotalNotaFiscal > 0
        && this.validarFormaPagamento();
    }

    if (this.props.dadosPagamentoEncomenda.habilitadoValorDeclarado) {
      return  this.props.dadosPagamentoEncomenda.valorProduto > 0
        && this.validarFormaPagamento();
    }

    return this.validarFormaPagamento();
  }

  validarFormaPagamento() {
    this.preencherFormaPagamento();
    const valorTotal = this.props.dadosPagamentoEncomenda.valorCombinado != 0 ? this.props.dadosPagamentoEncomenda.valorCombinado : this.props.dadosPagamentoEncomenda.valorCalculado;
    
    return this.props.dadosPagamentoEncomenda.formasPagamento
      && this.props.dadosPagamentoEncomenda.formasPagamento.length > 0
      && this.props.dadosPagamentoEncomenda.tipoProduto.length > 0
      && realParaNumber(valorTotal) > 0
      && (realParaNumber(valorTotal) + this.calcularValorSeguro()) === this.somarValorFormaPagamento();
  }

  tratarBotaoAvancar() {
    switch (this.state.abaSelecionada) {
      case 1: {
        return !this.props.viagem.idItinerario
      }
      case 2: {
        return !this.props.enderecoRemetente
      }
      case 3: {
        return !this.props.enderecoDestinatario
      }
      case 4: {
        return !this.tratarAvancarPagamento()
      }

      case 5: {
        return this.tratarAvancarCte();
      }

      default: {
        return false;
      }
    }
  }

  exibirBotoesRodape() {
    const aba = this.state.abaSelecionada;
    return (
      <div className="vx-footer-actions">
        <div className="vx-footer-left">
          {aba > 1 && aba !== 7 && (
            <button className="vx-btn-secondary" onClick={() => this.voltar()}>
              <i className="material-icons">arrow_back</i> Voltar
            </button>
          )}
        </div>
        <div className="vx-footer-right">
          {aba < 6 && (
            <button className="vx-btn-primary" onClick={() => this.avancar()} disabled={this.tratarBotaoAvancar()}>
              Avançar <i className="material-icons">arrow_forward</i>
            </button>
          )}
          {aba === 6 && (
            <button className="vx-btn-primary" onClick={() => this.criarEncomenda()}>
              Criar Encomenda <i className="material-icons">check</i>
            </button>
          )}
        </div>
      </div>
    );
  }

  exibirAbaSelecionada() {
    switch (this.state.abaSelecionada) {
      case 1: {
        return (<AbaItinerario avancar={this.avancar.bind(this)}/>)
      }

      case 2: {
        return (<AbaRemetente />)
      }

      case 3: {
        return (<AbaDestinatario />)
      }

      case 4: {
        return (<AbaPagamento
          verificarSeFormaPagamentoNaoFoiSelecionado={this.verificarSeFormaPagamentoNaoFoiSelecionado.bind(this)}
          recuperarValorTotal={this.recuperarValorTotal.bind(this)}
          calcularValorSeguro={this.calcularValorSeguro.bind(this)}
          recuperarValorTotalGeral={this.recuperarValorTotalGeral.bind(this)} />)
      }

      case 5: {
        return <AbaCte />
      }

      case 6: {
        return (<AbaResumo
          recuperarValorTotal={this.recuperarValorTotal.bind(this)}
          calcularValorSeguro={this.calcularValorSeguro.bind(this)}
          recuperarValorTotalGeral={this.recuperarValorTotalGeral.bind(this)} />)
      }
      // case 6: {
      //   return (<AbaRecibo/>)
      // }

      default: {
        return '';
      }
    }
  }

  exibir() {
    const { usuarioVendeEncomendaComCte } = this.props;
    const aba = this.state.abaSelecionada;

    const allSteps = [
      { num: 1, label: 'Itinerário' },
      { num: 2, label: 'Remetente' },
      { num: 3, label: 'Destinatário' },
      { num: 4, label: 'Pagamento' },
      { num: 5, label: 'Cte', conditional: true },
      { num: 6, label: 'Resumo' },
    ];

    const visibleSteps = allSteps.filter(s => !s.conditional || usuarioVendeEncomendaComCte);

    if (this.props.caixaAberto) {
      return (
        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
          <div className="vx-steps">
            {visibleSteps.map((s, i) => {
              const isDone = aba > s.num;
              const isActive = aba === s.num;
              return (
                <React.Fragment key={s.num}>
                  <div className={`vx-step${isDone || isActive ? ' vx-step--done' : ''}${isActive ? ' vx-step--active' : ''}`}>
                    <div className="vx-step-circle">
                      {isDone ? <i className="material-icons">check</i> : (i + 1)}
                    </div>
                    <span className="vx-step-label">{s.label}</span>
                  </div>
                  {i < visibleSteps.length - 1 && (
                    <div className={`vx-step-line${isDone ? ' vx-step-line--done' : ''}`} />
                  )}
                </React.Fragment>
              );
            })}
          </div>
          <div className='card border-0'>
            <div className='card-body' style={{ margin: '15px' }}>
              {this.exibirAbaSelecionada()}
            </div>
            {this.exibirBotoesRodape()}
          </div>
        </div>
      );
    }
    return (
      <div className='col-12'>
        <div className="mt-2 alert alert-warning text-center" role="alert">
          Seu caixa está em análise de fechamento. Para efetuar mais vendas contate seu gerente.
        </div>
      </div>
    );
  }

  render() {
    if (this.props.empresaSelecionada.habilitadoEncomenda) {
      return (
        <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}
          empresaSelecionada={this.props.empresaSelecionada}>
          <div>
            <div className="row internas">
              <Titulo texto="Nova Encomenda" urlRetorno="/menu-encomendas" />
              {this.exibir()}
            </div>
          </div>
        </Autorizacao>)
    }
    return '';
  }
}

const selector = formValueSelector('formularioCadastroEncomenda');

export const mapStateToProps = state => ({
  pedidos: state.pedidos.pedidos,
  empresaSelecionada: state.empresaSelecionada,
  changeFieldValue,
  filtrosAdicionados: state.filtrosAdicionadosPedido,
  caixaAberto: state.caixaAberto,
  viagem: state.viagem,
  enderecoDestinatario: state.enderecoDestinatario,
  enderecoRemetente: state.enderecoRemetente,
  pessoaRemetente: state.pessoaRemetente,
  pessoaDestinatario: state.pessoaDestinatario,
  dadosPagamentoEncomenda: state.dadosPagamentoEncomenda,
  configuracaoEncomenda: state.configuracaoEncomenda,
  origem: state.origem,
  destino: state.destino,
  cartao: selector(state, 'cartao'),
  pix: selector(state, 'pix'),
  valorCartao: selector(state, 'valorCartao'),
  dinheiro: selector(state, 'dinheiro'),
  valorDinheiro: selector(state, 'valorDinheiro'),
  valorPIX: selector(state, 'valorPIX'),
  nomeComprovanteVenda: selector(state, 'nomeComprovanteVenda'),
  numeroComprovante: selector(state, 'numeroComprovante'),
  base64Comprovante: selector(state, 'base64Comprovante'),
  nomeComprovanteVendaPIX: selector(state, 'nomeComprovanteVendaPIX'),
  numeroComprovantePIX: selector(state, 'numeroComprovantePIX'),
  base64ComprovantePIX: selector(state, 'base64ComprovantePIX'),
  quantidadeParcelas: selector(state, 'quantidadeParcelas'),
  imagens: state.imagensEncomenda.arquivos,
  usuarioVendeEncomendaComCte: state.usuarioVendeEncomendaComCte,
  rntrc: selector(state, 'rntrc'),
  chaveNfe: selector(state, 'chaveNfe'),
  dadosCteEncomenda: state.dadosCteEncomenda
});


export default withRouter(connect(mapStateToProps,
    {
      buscarCaixaAberto,
      selecionarEnderecoDestinatario,
      selecionarEnderecoRemetente,
      buscarPessoaRemetentePorCpfCnpj,
      buscarPessoaDestinatarioPorCpfCnpj,
      selecionarPessoaRemetente,
      selecionarPessoaDestinatario,
      selecionarDestino,
      selecionarOrigem,
      selecionarDataIda,
      selecionarViagem,
      limparViagens,
      cadastrarEncomenda,
      limparDadosPagamentoEncomenda,
      adicionarFormasPagamentoEncomenda,
      buscarConfiguracaoEncomenda,
      buscarOpcoesFiltrosEmissaoesCte,
      buscarSeUsuarioVendeEncomendaComCte,
      adicionarDadosCteEncomenda,
      limparDadosCteEncomenda
    })(reduxForm({
      form: 'formularioCadastroEncomenda',
      enableReinitialize: true,
      destroyOnUnmount: true,
      forceUnregisterOnUnmount: true
    })(PainelCadastroEncomenda)));
